import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for R5M3 (Inventory Shipment Reversal)
// ============================================================

export interface WriteoffItem {
  fm130_01: string;         // Shipment no (PK)
  fm130_11: string | null;  // Shipment date (ISO string)
  fm130_16: string;         // Company code
  fm130_12: number;         // Total shipment qty
  fm130_13: string;         // Unit
  fm130_20: string;         // Customer code
  fm130_14: number;         // Shipment total amount
  company_name: string;     // Company name (from F106)
}

export interface QueryResponse {
  items: WriteoffItem[];
  total: number;
}

export interface ValidateItemResponse {
  valid: boolean;
  message?: string;
}

export interface ExecuteResponse {
  success: number;
  failed: number;
  errors?: string[];
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const r5m3Api = {
  /** Query shipment items within a range */
  async query(startNo: string, endNo: string): Promise<QueryResponse> {
    const res = await apiClient.post('/api/r5m3/query', {
      start_no: startNo,
      end_no: endNo,
    });
    return res.data;
  },

  /** Validate a single item for writeoff eligibility */
  async validateItem(shipmentNo: string): Promise<ValidateItemResponse> {
    const res = await apiClient.post('/api/r5m3/validate-item', {
      shipment_no: shipmentNo,
    });
    return res.data;
  },

  /** Execute batch writeoff for selected items */
  async execute(shipmentNos: string[]): Promise<ExecuteResponse> {
    const res = await apiClient.post('/api/r5m3/execute', {
      shipment_nos: shipmentNos,
    });
    return res.data;
  },
};
